import CabecalhoPaginaSecundaria from "../../../componentes/comuns/CabecalhoPaginaSecundaria";
// =======================
// src/paginas/adminPage/modalidades/EditarModalidade.js
// =======================

import React, { useState, useEffect } from "react";

import { Box, TextField, Button, Typography, Checkbox, FormControlLabel, Paper, CircularProgress } from "@mui/material";

import { styled } from "@mui/system";

import { useNavigate, useParams } from "react-router-dom";
import axios from "axios";


import ErrorState from "@componentes/ErrorWindow";
import { api } from "@api/api";

import TransicaoPagina from "../../../componentes/comuns/TransicaoPagina";
import { ajustarTamanhoFonteSre } from "../../../estilos/global";

// Container principal com gradiente e sombra.
const GradientPaper = styled(Paper)(({ theme }) => ({
  padding: theme.spacing(6),
  borderRadius: "24px",
  background: "linear-gradient(145deg, var(--sear-superficie, #ffffff), var(--sear-superficie-azul, #f5f7ff))",
  boxShadow: "0 20px 50px rgba(63, 81, 181, 0.15)",
  maxWidth: "600px",
  margin: "auto",
  marginTop: "5%",
  position: "relative",
  overflow: "hidden",

  "&::before": {
    content: '""',
    position: "absolute",
    top: 0,
    left: 0,
    right: 0,
    height: "6px",
    background: "linear-gradient(90deg, #3f51b5, #2196f3)",
  },
}));

// Botão com efeito de onda ao clicar.
const RippleButton = styled(Button)(() => ({
  position: "relative",
  overflow: "hidden",
  transition: "all 0.3s cubic-bezier(0.4, 0, 0.2, 1)",

  "&::after": {
    content: '""',
    position: "absolute",
    top: "50%",
    left: "50%",
    width: "5px",
    height: "5px",
    background: "var(--sear-superficie, rgba(255, 255, 255, 0.5))",
    opacity: 0,
    borderRadius: "100%",
    transform: "scale(1, 1) translate(-50%)",
    transformOrigin: "50% 50%",
  },

  "&:active::after": {
    animation: "ripple 0.6s ease-out",
  },

  "@keyframes ripple": {
    "0%": {
      transform: "scale(0, 0) translate(-50%)",
      opacity: 1,
    },

    "100%": {
      transform: "scale(20, 20) translate(-50%)",
      opacity: 0,
    },
  },
}));

const EdicaoModalidadePage = () => {
  const { id } = useParams();
  const navigate = useNavigate();

  const [nomeModalidade, setNomeModalidade] = useState("");
  const [isEnsinoInfantil, setIsEnsinoInfantil] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isUpdating, setIsUpdating] = useState(false);
  const [errorType, setErrorType] = useState(null);

  useEffect(() => {
    const fetchModalidade = async () => {
      try {
        const response = await axios.get(api.adminGetModality(id), {
          withCredentials: true,
        });

        const { nome, ensino_infantil } = response.data;

        setNomeModalidade(nome);
        setIsEnsinoInfantil(ensino_infantil);
      } catch (error) {
        console.error("Erro ao editar a modalidade:", error);

        if (error.message.includes("Network Error")) {
          setErrorType("network");
        } else if (error.response?.status === 403) {
          setErrorType("permission");
        } else {
          setErrorType("module");
        }
      } finally {
        setLoading(false);
      }
    };

    fetchModalidade();
  }, [id]);

  const handleUpdate = async () => {
    if (!nomeModalidade.trim()) return;

    setIsUpdating(true);

    try {
      const payload = {
        nome: nomeModalidade.trim(),
        ensino_infantil: isEnsinoInfantil,
      };

      await axios.patch(api.adminEditModality(id), payload, {
        headers: {
          "Content-Type": "application/json",
        },
        withCredentials: true,
      });

      navigate(-1);
    } catch (error) {
      console.error("Erro ao atualizar a modalidade:", error);
    } finally {
      setIsUpdating(false);
    }
  };

  if (loading) {
    return (
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          minHeight: "100vh",
          background: "linear-gradient(135deg, var(--sear-superficie-azul, #f5f7ff) 0%, var(--sear-superficie-azul, #f0f4ff) 100%)",
        }}
      >
        <CircularProgress size={60} thickness={4} sx={{ color: "var(--sear-azul, #3f51b5)" }} />
      </Box>
    );
  }

  if (errorType) {
    return (
      <ErrorState
        errorType={errorType}
        onRetry={() => {
          setErrorType(null);
        }}
      />
    );
  }

  return (
    <TransicaoPagina variante="navegacao">
      <Box
        sx={{
          minHeight: "100vh",
          display: "flex",
          alignItems: "center",
          background: "linear-gradient(135deg, var(--sear-superficie-azul, #f5f7ff) 0%, var(--sear-superficie-azul, #f0f4ff) 100%)",
          p: 3,
        }}
      >
        <GradientPaper elevation={3}>
          {/* Botão Voltar */}
          <CabecalhoPaginaSecundaria
            titulo="Editar Modalidade"
            sx={{ mb: 3 }}
            onVoltar={() => navigate(-1)}
          />

          {/* Formulário */}
          <Box component="form" sx={{ mt: 3 }}>
            <div>
              <TextField
                label="Nome da Modalidade"
                variant="outlined"
                fullWidth
                value={nomeModalidade}
                onChange={(e) => setNomeModalidade(e.target.value)}
                sx={{
                  marginBottom: 3,

                  "& .MuiOutlinedInput-root": {
                    borderRadius: "12px",
                    backgroundColor: "var(--sear-superficie, rgba(255, 255, 255, 0.9))",
                    boxShadow: "0 4px 12px rgba(0, 0, 0, 0.05)",

                    "& fieldset": {
                      borderColor: "var(--sear-borda-forte, rgba(63, 81, 181, 0.2))",
                    },

                    "&:hover fieldset": {
                      borderColor: "var(--sear-borda-forte, rgba(63, 81, 181, 0.4))",
                    },

                    "&.Mui-focused fieldset": {
                      borderColor: "var(--sear-borda-forte, #3f51b5)",
                      boxShadow: "0 0 0 2px rgba(63, 81, 181, 0.2)",
                    },
                  },

                  "& .MuiInputLabel-root": {
                    color: "var(--sear-azul, rgba(63, 81, 181, 0.7))",
                  },
                }}
              />
            </div>

            <div>
              <FormControlLabel
                control={
                  <Checkbox
                    checked={isEnsinoInfantil}
                    onChange={(e) => setIsEnsinoInfantil(e.target.checked)}
                    sx={{
                      color: "var(--sear-azul, #3f51b5)",

                      "&.Mui-checked": {
                        color: "var(--sear-azul, #3f51b5)",
                      },
                    }}
                  />
                }
                label={
                  <Typography variant="body1" sx={{ color: "text.secondary" }}>
                    Educação Infantil
                  </Typography>
                }
                sx={{
                  marginBottom: 4,
                  padding: 1,
                  borderRadius: "8px",
                  backgroundColor: isEnsinoInfantil
                    ? "rgba(255, 152, 0, 0.08)"
                    : "transparent",
                  transition: "all 0.3s ease",
                }}
              />
            </div>

            <div>
              <RippleButton
                variant="contained"
                fullWidth
                onClick={handleUpdate}
                disabled={!nomeModalidade.trim() || isUpdating}
                sx={{
                  borderRadius: "12px",
                  padding: "14px",
                  fontSize: ajustarTamanhoFonteSre("16px"),
                  fontWeight: 600,
                  background: "linear-gradient(90deg, #3f51b5, #2196f3)",
                  color: "#ffffff",
                  boxShadow: "0 8px 20px rgba(63, 81, 181, 0.3)",

                  "&:hover": {
                    boxShadow: "0 12px 24px rgba(63, 81, 181, 0.4)",
                    transform: "translateY(-2px)",
                  },

                  "&:disabled": {
                    background: "var(--sear-superficie-suave, rgba(0, 0, 0, 0.12))",
                    color: "var(--sear-texto, rgba(0, 0, 0, 0.26))",
                  },
                }}
              >
                {isUpdating ? (
                  <CircularProgress size={24} color="inherit" />
                ) : (
                  "Salvar Alterações"
                )}
              </RippleButton>
            </div>
          </Box>
        </GradientPaper>
      </Box>
    </TransicaoPagina>
  );
};

export default EdicaoModalidadePage;
